/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Input, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { logIn, resetErrorMessage, setUsername } from '../../store/routines';
import routes from '../../common/constants/RouteConstants';
import InputValidationMessage from '../../components/InputMessageContainers/InputValidationMessage';
import { cognitoLoginErrorMessageFormatter } from '../../common/util/authUtils';
import {
  PRIVACY_POLICY_URL,
  TERMS_URL,
} from '../../common/constants/CommonConstants';

const feature = 'login-form';

function LoginForm() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = Form.useForm();

  const errorMessage = useSelector((state) => state.auth.errorMessage);
  const isError = useSelector((state) => state.auth.isLoginError);
  const [errorVisible, setErrorVisible] = useState(false);

  const onLogin = (values) => {
    const { username, password, remember } = values;
    dispatch(setUsername({ username: username.trim() }));
    dispatch(logIn({ username: username.trim(), password, remember }));
  };

  useEffect(() => {
    if (errorMessage) {
      setErrorVisible(true);
    }
  }, [errorMessage]);

  const onFormChange = (changedValues) => {
    if (changedValues) {
      setErrorVisible(false);
    }
  };

  // useEffect(() => {
  //   return () => {
  //     dispatch(resetErrorMessage());
  //   };
  // }, []);

  const handleForgotPassword = () => {
    history.push(routes.loginManagement.forgotPassword);
  };

  const handleLoginWithSSO = () => {
    history.push(routes.loginManagement.ssoLogin);
  };

  return (
    <>
      <div className="login-input-wrapper">
        <div className="title">Welcome Back!</div>
        <Form
          form={form}
          name="login_step_1"
          className="login-form"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={onLogin}
          onValuesChange={onFormChange}
        >
          {isError && errorVisible && (
            <div className="login-error-bar" data-testid={`${feature}-err-msg`}>
              <i className="icon core-icon core-alert-outlined" />{' '}
              {cognitoLoginErrorMessageFormatter(errorMessage)}
            </div>
          )}

          <Form.Item
            name="username"
            label="Username"
            className="login-field"
            rules={[
              {
                required: true,
                message: (
                  <InputValidationMessage
                    message="Please enter your username"
                    data-testid={`${feature}-username`}
                  />
                ),
              },
            ]}
          >
            <Input
              className="login-field"
              placeholder="Email Address"
              autoFocus
              data-testid={`${feature}-username-txtin`}
            />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            className="login-field password"
            rules={[
              {
                required: true,
                message: (
                  <InputValidationMessage
                    message="Please enter your password"
                    data-testid={`${feature}-pw`}
                  />
                ),
              },
            ]}
          >
            <Input.Password
              className="login-field"
              data-testid={`${feature}-pwin`}
            />
          </Form.Item>
          <Form.Item className="login-field forgot-wrapper">
            <a
              tabIndex={0}
              role="button"
              className="forgot"
              onClick={handleForgotPassword}
              data-testid={`${feature}-forgot-pw-link`}
            >
              Forgot your password?
            </a>
          </Form.Item>
          {/* <Form.Item
            name="remember"
            valuePropName="checked"
            className="login-field remember"
          >
            <Checkbox>Remember me</Checkbox>
          </Form.Item> */}

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button loginbtn"
              data-testid={`${feature}-login-btn`}
            >
              Log In
            </Button>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button ssobtn"
              onClick={handleLoginWithSSO}
              data-testid={`${feature}-sso-login-btn`}
            >
              Log In with SSO
            </Button>
          </Form.Item>
        </Form>

        <div className="terms-policies">
          <p>
            By logging in, you agree to the{' '}
            <a
              href={TERMS_URL}
              target="_blank"
              rel="noreferrer"
              data-testid={`${feature}-terms-of-service-link`}
            >
              Terms of Service
            </a>{' '}
            and{' '}
            <a
              href={PRIVACY_POLICY_URL}
              target="_blank"
              rel="noreferrer"
              data-testid={`${feature}-privacy-policy-link`}
            >
              Privacy Policy
            </a>
          </p>
        </div>
      </div>
      <div className="filler"> </div>
    </>
  );
}

export default LoginForm;
